import AsyncSelect from 'react-select/async';
import type { MultiValue } from 'react-select';
import { FILTER_SELECT_WIDTH, filterSelectStyles } from './selectStyles';
import type { SelectOption } from './selectTypes';

type Props = {
  value: SelectOption[];
  onChange: (value: SelectOption[]) => void;
  /** Called with the typed text; the picked options are kept in `value`. */
  search: (query: string) => Promise<SelectOption[]>;
  placeholder?: string;
  width?: number | string;
};

/** Multi select whose options are searched on the server while typing. */
export const AsyncMultiSelect = ({
  value,
  onChange,
  search,
  placeholder = 'Начните вводить...',
  width = FILTER_SELECT_WIDTH,
}: Props) => (
  <AsyncSelect
    isMulti
    value={value}
    loadOptions={search}
    onChange={(next: MultiValue<SelectOption>) => onChange([...next])}
    placeholder={placeholder}
    loadingMessage={() => 'Загрузка...'}
    noOptionsMessage={({ inputValue }) => (inputValue ? 'Ничего не найдено' : 'Введите запрос')}
    styles={filterSelectStyles<true>(width)}
    classNamePrefix="filter-multi"
  />
);
